import { render, staticRenderFns } from "./StockAD.vue?vue&type=template&id=171ba042&scoped=true"
import script from "./StockAD.vue?vue&type=script&lang=js"
export * from "./StockAD.vue?vue&type=script&lang=js"
import style0 from "./StockAD.vue?vue&type=style&index=0&id=171ba042&prod&scoped=true&lang=css"
import style1 from "./StockAD.vue?vue&type=style&index=1&id=171ba042&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171ba042",
  null
  
)

export default component.exports